import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { Box, Flex, Text } from 'rebass';

const ToggleContainer = styled(Flex)`
  width: 50px;
  height: 24px;
  border-radius: 15px;
  background-color: ${props => (props.toggled ? '#9B59B6' : '#757575')};
  align-items: center;
  justify-content: ${props => (props.toggled ? 'flex-end' : 'flex-start')};
  padding: 0 6px;
  cursor: ${props => (props.isSubmitting ? 'not-allowed' : 'pointer')};
  opacity: ${props => (props.isSubmitting ? 0.6 : 1)};
  transition: background-color 0.3s ease, justify-content 0.3s ease;
`;

const ToggleCircle = styled(Box)`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  color: ${props => (props.toggled ? '#9B59B6' : '#757575')};
  transition: background-color 0.3s ease;
`;

const RadioToggle = ({ initial = false, noToggle = false, isSubmitting, onToggle, label, style }) => {
    const [toggled, setToggled] = useState(initial);

    useEffect(() => {
        setToggled(initial)
    }, [initial])

    const handleToggle = () => {
        if (noToggle) return
        const newValue = !toggled;
        setToggled(newValue);
        if (onToggle) onToggle(newValue);
    };

    return (<Box>
        {label}
        <ToggleContainer
            toggled={toggled}
            isSubmitting={isSubmitting}
            onClick={handleToggle}
            role="switch"
            aria-checked={toggled}
            style={style}
        >
            <ToggleCircle toggled={toggled}>
                {toggled ? '✓' : `✕`}
            </ToggleCircle>
        </ToggleContainer>
    </Box>
    );
};

export default RadioToggle;